exports.components = {
  "component---src-templates-advanced-page-template-index-js": () => import("./../../../src/templates/AdvancedPageTemplate/index.js" /* webpackChunkName: "component---src-templates-advanced-page-template-index-js" */),
  "component---src-templates-landing-page-template-index-js": () => import("./../../../src/templates/LandingPageTemplate/index.js" /* webpackChunkName: "component---src-templates-landing-page-template-index-js" */)
}

